export default __webpack_public_path__ + "static/media/80s_bg_left.d58d31b3.jpg";